/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useEffect, useState } from "react";
import { navItems } from "sections/menu-config";
import { useRBAC } from "cms/auth/hooks/use-RBAC";
import { useOrgSettings } from "hooks/use-org-settings";
import { exists } from "utils/empty-exists";
import { useSelector } from "react-redux";

const useAllowedMenu = function () {

    const [menu,setMenu] = useState([]);
    const [hasFlags,setHasFlags] = useState([]);
    const { permissionsReady, checkPermission } = useRBAC();
    const { getOrgSettingsBoolean } = useOrgSettings();
    const all = useSelector((state) => state.orgSettings.all);

    const buildMenu = async () => {
        const _menu = [];
        for (const menu_item of navItems) {
            const _permission = menu_item?.permission;
            const feature_flag = menu_item?.feature_flag;
            const hasPermission = await checkPermission(_permission);
            if (hasPermission) {
                if (exists(feature_flag)) {
                    const hasFeature = getOrgSettingsBoolean(feature_flag);
                    // console.log(feature_flag, hasFeature);
                    if (hasFeature) {
                        _menu.push(menu_item);
                    }
                } else {
                    _menu.push(menu_item);
                }
            }
        }
        setMenu(_menu);
    };
    useEffect(() => {
        if (permissionsReady) {
            buildMenu();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[permissionsReady]);
    useEffect(() => {
        if (!hasFlags && exists(all)) {
            buildMenu();
        }
        setHasFlags(exists(all));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[all]);

    return { menu };
};

export { useAllowedMenu };
